import { render } from "./PharmacyManagement.vue?vue&type=template&id=b161a2dc&scoped=true"
import script from "./PharmacyManagement.vue?vue&type=script&lang=js"
export * from "./PharmacyManagement.vue?vue&type=script&lang=js"

import "./PharmacyManagement.vue?vue&type=style&index=0&id=b161a2dc&lang=css"
import "./PharmacyManagement.vue?vue&type=style&index=1&id=b161a2dc&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b161a2dc"]])

export default __exports__